import React, { useEffect, useMemo, useState } from "react";
import "../../App.css";
import {
  ChipField,
  Datagrid,
  FunctionField,
  ListContextProvider,
  SearchInput,
  useDataProvider,
  useGetList,
  useList,
  useCreate,
  useListContext,
  useRecordContext,
  useGetIdentity,
  usePermissions,
  useGetOne,
  useNotify,
  ReferenceField,
} from "react-admin";
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Button as MuiButton,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import IconButton from "@mui/material/IconButton";
import FilterModel from "./FilterModel";
import { notifyPopupBlocked, openWithPopupCheck } from "../../utils/popupWindow";
import VrReportOptionsMenu from "../common/VrReportOptionsMenu";
import { QuickLookProvider } from "../common/QuickLook/quickLookContext";
import { TableHead, TableRow, TableCell } from "@mui/material";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import InfoIcon from "@mui/icons-material/Info";
import { DatagridBody, RecordContextProvider } from "react-admin";
import CircularProgress, {
  CircularProgressProps,
} from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import ErrorIcon from "@mui/icons-material/Error";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import FolderIcon from "@mui/icons-material/Folder";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ArchiveAplicant from "./ArchiveAplicant";
import { useParams, useNavigate } from "react-router-dom";
import SendEmailToApplicant from "./SendEmailToApplicant";
import ApplicantNameEdit from "./ApplicantNameEdit";
import ReAddApplicant from "./ReAddApplicant";
import { typesofUsers } from "../../config";
import ResendInvite from "./ResendInvite";
import { BiSolidFilePdf } from "react-icons/bi";
import { checkModuleAccess, isSuperAdmin } from "../../Functions/permissions";
import { TotalGrossPay } from "../../utils/TotalGrossPay";
import { TotalNetPay } from "../../utils/TotalNetPay";
import { PayVerticalTile } from "../Molecules/PayVerticalTile/PayVerticalTile";
import { IncomeBankingField } from "./Fields/IncomeBankingField";
import { DocumentField, resolveAppType, canViewPIIForId, isAdminRole } from "./Fields/AtsFields";
import { updateNewTagsForApplicantsUnconditional } from "../../utils/newTag";
import { canShowScreeningScoreForViewer, shouldHideSystemAssessment, isManualReviewerRole } from "../../utils/screeningScore";
import { useSelector } from "react-redux";
import RiskFlagAlert from "../common/RiskFlagAlert";
import { canViewSerialFraudDashboardIndicator } from "../../utils/serialFraudDashboard";
import { isExistingVrResultVisible } from "../../utils/atsApplicationStatus";


// Validates a raw source_id/EmployerNumber value into a source slot (1-3), same rule
// ProofOfEmploymentIncome/index.tsx uses, so an unrelated field value can't be mistaken
// for a real source number.
const parseSourceId = (value: any): number | null => {
  const parsed = Number.parseInt(String(value), 10);
  if (!Number.isFinite(parsed) || parsed < 1 || parsed > 3) return null;
  return parsed;
};

export const ToogleFilterInboxType = (props) => {
  const { setFilters, filterValues, displayedFilters } = useListContext();
  useEffect(() => {
    if (!filterValues.app_invitation_type) {
      setFilters({ app_invitation_type: "1" }, displayedFilters);
    }
  }, []);
  return (
    <>
      {/* <JSONTree data={filterValues}/> */}
      <ToggleButtonGroup
        sx={{ paddingBottom: 0.5, "& .Mui-selected": { fontWeight: 700 } }}
        size="small"
        value={filterValues.app_invitation_type}
        color="primary"
        exclusive
        onChange={(
          event: React.MouseEvent<HTMLElement>,
          newAlignment: string
        ) => {
          if (newAlignment) {
            setFilters({ app_invitation_type: newAlignment }, displayedFilters);
          }
        }}
        aria-label="Inbox"
      >
        <ToggleButton value={"1"} aria-label="Application">
          Application
        </ToggleButton>
        <ToggleButton value={"2"} aria-label="Docupload">
          Docupload
        </ToggleButton>
        <ToggleButton value={"3"} aria-label="Docupload">
          Guest Card
        </ToggleButton>
      </ToggleButtonGroup>
    </>
  );
};

export const FilterListInbox = (props) => {
  return (
    <>
      {/* <Button size='large' variant='outlined' startIcon={} label='' onClick={() => { }} /> */}
      <IconButton
        sx={{
          border: "1px solid",
          borderRadius: " 5px",
          padding: "6px",
          marginLeft: "-10px",
          marginBottom: "4.4px",
        }}
        size="medium"
        aria-label="delete"
      >
        <FilterListIcon />
      </IconButton>
    </>
  );
};

export const filters = [
  <SearchInput
    variant="outlined"
    sx={{ backgroundColor: "#fff" }}
    placeholder="Search"
    InputLabelProps={{
      shrink: true,
    }}
    source="q"
    alwaysOn
  />,
  <FilterModel source="filterList" alwaysOn />,
  <ToogleFilterInboxType source="app_invitation_type" alwaysOn />,

  // <TextInput alwaysOn label="Title" source="Property" variant="outlined" sx={{ backgroundColor: '#fff' }}    />,
];

export default function BasicPopover() {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <IconButton
        color="warning"
        style={{ color: "#F9BB04" }}
        size="small"
        aria-label="info"
        aria-describedby={id}
        onClick={handleClick}
      >
        <InfoIcon style={{ fontSize: "14" }} />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Typography sx={{ p: 2 }}>This is the Rent to Income Ratio.</Typography>
      </Popover>
    </div>
  );
}

const DatagridTableHeaderCell = ({ child, data }) => {
  const subtitle = child?.props?.subtitle ?? child?.type?.subtitle;
  return (
    <div
      className="badge-cell"
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <div style={{ minHeight: 16, lineHeight: '16px' }}>
        {child.props.label || child.props.source}
      </div>
      <div
        style={{
          marginTop: 2,
          minHeight: 16,
          lineHeight: '16px',
        }}
      >
        {subtitle || '\u00A0'}
      </div>
    </div>
  );
};

const DatagridHeader = (props) => {
  const { children, data } = props;
  return (
    <TableHead
      sx={{ backgroundColor: "#FFFFFF", border: "0.5px solid #E0E0E0" }}
    >
      <TableRow>
        {React.Children.map(children, (child) => {
          if (child)
            if (!child.props?.hidden)
              return (
                <TableCell
                  padding="none"
                  sx={{ p: 1 }}
                  key={child?.props?.source}
                >
                  <DatagridTableHeaderCell child={child} data={data} />
                </TableCell>
              );
        })}
      </TableRow>
    </TableHead>
  );
};

const MyDatagridRow = (props) => {
  const { record, id, children } = props;
  return (
    <RecordContextProvider value={record}>
      <TableRow className={props.className}>
        {React.Children.map(children, (field) => {
          if (field)
            if (!field.props?.hidden)
              return (
                <TableCell
                  padding="none"
                  data-label={field?.props?.label || field?.props?.source}
                  sx={{ p: 1 }}
                  key={`${id}-${field?.props?.source}`}
                >
                  {field}
                </TableCell>
              );
        })}
      </TableRow>
    </RecordContextProvider>
  );
};

const MyDatagridBody = (props) => (
  <DatagridBody {...props} row={<MyDatagridRow />} />
);
const MyDatagrid = (props) => <Datagrid {...props} body={<MyDatagridBody />} />;

export const successScreenStyle = {
  border: " 1px solid #46A96F",
  background: "#E6FDF0",
  width: 40,
  height: 40,
  borderRadius: 50,
  margin: "0px 40px",
  p: 1,
};
export const errorScreenStyle = {
  background: "#FFEEEE",
  /* Error */
  border: "1px solid #FF4848",
  width: 40,
  height: 40,
  borderRadius: 50,
  margin: "0px 40px",
  p: 1,
};
export const warnScreenStyle = {
  background: "#FFF8E2",
  border: "1px solid #FFDA6A",
  width: 40,
  height: 40,
  borderRadius: 50,
  margin: "0px 40px",
  p: 1,
};

export const appStatusStyle = {
  padding: "8px 7px",
  borderRadius: "4px",
  fontWeight: "600",
  fonSize: "12px",
  lineHeight: "16px",
};

export const screenedAppStatusStyle = {
  ...appStatusStyle,
  background: "#FFF8E2",
  color: "#F9BB04",
};

export const invitedAppStatusStyle = {
  ...appStatusStyle,
  background: "#E9E9E9",
  color: "#909090",
};

export const inProgressAppStatusStyle = {
  ...appStatusStyle,
  background: "#DDF8FF",
  color: "#1CA2C2",
};

function CircularProgressWithLabel(
  props: CircularProgressProps & { value: number }
) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        variant="determinate"
        size="30px"
        {...props}
        sx={{ color: props?.value === 100 ? "green" : "orange" }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 40,
          border:
            props?.value === 100
              ? "0"
              : props?.value === 0
                ? "2px solid #E0E0E0"
                : "1px solid #E0E0E0",
        }}
      >
        {props?.value === 100 ? (
          <CheckIcon style={{ color: "green" }} />
        ) : (
          <Typography
            variant="caption"
            component="div"
            color="text.secondary"
          >{`${Math.round(props.value)}%`}</Typography>
        )}
      </Box>
    </Box>
  );
}

export function CircularStatic() {
  const record = useRecordContext();
  return (
    <>
      <CircularProgressWithLabel
        value={
          record.ApplicantStatus == "Invited"
            ? 0
            : Number(record.ApplicationCompleted)
        }
      />
    </>
  );
}


function IdField({
                   appType,
                   filterValues,
                   getUserData,
                   permissions,
                   onClickIndividualDocsHandler,
                   viewerRole,
                   applicationStatus,
                   source = "ID",
                   label = "ID",
                 }: {
  appType: any;
  filterValues: any;
  getUserData: any;
  permissions: any;
  onClickIndividualDocsHandler: (event: any, record: any, documentType: string) => void;
  viewerRole?: string;
  applicationStatus?: string;
  source?: string;
  label?: string;
}) {
  const userrole = getUserData?.userrole;
  const resolvedType = resolveAppType(appType, filterValues);
  const canShow = canViewPIIForId(resolvedType, permissions, userrole, isSuperAdmin, checkModuleAccess);
  if (!canShow) return null;

  return (
    <DocumentField
      label={label}
      source={source}
      filterValues={filterValues}
      presentKey="IDS"
      requiredKey="IsRequiredID"
      newTagKey="NewTagID"
      socrStatusKey="IDSOCRStatus"
      documentType="ID"
      onClick={onClickIndividualDocsHandler}
      viewerRole={viewerRole}
      applicationStatus={applicationStatus}
      reviewedKey="IDReviewed"
    />
  );
}

function SsnField({
                    appType,
                    filterValues,
                    getUserData,
                    permissions,
                    onClickIndividualDocsHandler,
                    viewerRole,
                    applicationStatus,
                    source = "SSN",
                    label = "SSN",
                  }: {
  appType: any;
  filterValues: any;
  getUserData: any;
  permissions: any;
  onClickIndividualDocsHandler: (event: any, record: any, documentType: string) => void;
  viewerRole?: string;
  applicationStatus?: string;
  source?: string;
  label?: string;
}) {
  const userrole = getUserData?.userrole;
  const resolvedType = resolveAppType(appType, filterValues);
  const canShow = resolvedType !== "3" && isSuperAdmin(checkModuleAccess(permissions, "Inbox", "View PII"), userrole);
  if (!canShow) return null;

  return (
    <DocumentField
      label={label}
      source={source}
      filterValues={filterValues}
      presentKey="SSN"
      requiredKey="IsRequiredSSN"
      newTagKey="NewTagSSN"
      socrStatusKey="SSNSOCRStatus"
      documentType="SSN"
      onClick={onClickIndividualDocsHandler}
      hideOnGuestCard
      viewerRole={viewerRole}
      applicationStatus={applicationStatus}
      reviewedKey="SSNReviewed"
    />
  );
}

function IncomeTiles({
  payrollEmployers = [],
  trnId,
}: {
  payrollEmployers?: any[];
  trnId?: any;
}) {
  return (
    <ReferenceField source="Trnid" reference="incomeMany" link={false}>
      <IncomeTilesContent payrollEmployers={payrollEmployers} trnId={trnId} />
    </ReferenceField>
  );
}

function IncomeTilesContent({
  payrollEmployers = [],
  trnId,
}: {
  payrollEmployers?: any[];
  trnId?: any;
}) {
  const record: any = useRecordContext();
  const shouldIncludeEmploymentIncome =
    record?.employment_details?.response === "Yes";
  // Same resource/id EmployerSource.tsx fetches per employer card - react-admin/react-query
  // dedupes this against those calls, so this adds no extra request.
  const { data: validationCheckForTotals } = useGetOne(
    "getEmployerValidationCheck",
    { id: trnId },
    { enabled: trnId != null, refetchOnWindowFocus: true }
  );
  const employmentSOCRStatus = record?.employment_details?.SOCRstatus || {};
  // Unverifiable (SOCRStatus 2) employers must not count toward the displayed total, but a
  // valid employer on the same application still contributes its income — the overall
  // "Invalid" badge for this row (driven separately by record.IncomeSOCRStatus) is not
  // affected by this filtering, it only decides what the Gross/Net dollar figures sum.
  const employerSource = shouldIncludeEmploymentIncome
    ? (record?.employment_details?.employer || []).filter(
        (employer: any, idx: number) => {
          const sourceNum =
            parseSourceId(employer?.source_id) ??
            parseSourceId(employer?.EmployerNumber) ??
            idx + 1;
          const status =
            employmentSOCRStatus?.[`Source_${sourceNum}`] ??
            validationCheckForTotals?.other_check?.[`source_${sourceNum}`]?.SOCRStatus;
          return Number(status) !== 2;
        }
      )
    : [];
  const totalGrossPay = shouldIncludeEmploymentIncome
    ? TotalGrossPay(employerSource)
    : 0;
  const totalNetPay = shouldIncludeEmploymentIncome
    ? TotalNetPay(employerSource)
    : 0;
  const plaidMonthlyGross = shouldIncludeEmploymentIncome
    ? (Array.isArray(payrollEmployers) ? payrollEmployers : []).reduce(
        (sum: number, employer: any) => sum + (employer?.avgMonthlyGross ?? 0),
        0
      )
    : 0;
  const plaidMonthlyNet = shouldIncludeEmploymentIncome
    ? (Array.isArray(payrollEmployers) ? payrollEmployers : []).reduce(
        (sum: number, employer: any) => sum + (employer?.avgMonthlyNet ?? 0),
        0
      )
    : 0;

  return (
    <div className="py-1">
      <PayVerticalTile label="Gross" totalPay={totalGrossPay + plaidMonthlyGross} />
      <PayVerticalTile label="Net" totalPay={totalNetPay + plaidMonthlyNet} />
    </div>
  );
}

function IncomeField({
                       filterValues,
                       onClickIndividualDocsHandler,
                       viewerRole,
                       applicationStatus,
                       source = "Income",
                       label = "Income"
                     }: {
  filterValues: any;
  onClickIndividualDocsHandler: (event: any, record: any, documentType: string) => void;
  viewerRole?: string;
  applicationStatus?: string;
  source?: string;
  label?: string;
}) {
  const record: any = useRecordContext();
  const trnId = record?.Trnid || record?.trn_id || record?.id;
  const { data: payrollData } = useGetOne(
    "plaidPayrollIncomeValidationCheck",
    { id: trnId },
    { enabled: !!trnId, refetchOnWindowFocus: true }
  );
  const { data: argylePayrollData } = useGetOne(
    "argylePayrollIncomeValidationCheck",
    { id: trnId },
    { enabled: !!trnId, refetchOnWindowFocus: true }
  );
  const argylePayrollEmployers = useMemo(() => {
    const responses = argylePayrollData?.responses;
    if (!Array.isArray(responses)) return [];
    const flat: any[] = [];
    responses.forEach((response: any) => {
      const normalized = response?.normalized;
      if (Array.isArray(normalized)) normalized.forEach((employer: any) => flat.push(employer));
    });
    return flat;
  }, [argylePayrollData?.responses]);
  const payrollEmployers = useMemo(() => {
    const plaid = Array.isArray(payrollData?.payrollEmployers)
      ? payrollData.payrollEmployers
      : [];
    return [...plaid, ...argylePayrollEmployers];
  }, [payrollData?.payrollEmployers, argylePayrollEmployers]);
  const hasLinkedPayrollEmployers = payrollEmployers.length > 0;
  const hasPendingPayrollSource = Array.isArray(payrollData?.payrollSourceStatuses)
    ? payrollData.payrollSourceStatuses.some((status: any) =>
        String(status?.status || "").trim().toLowerCase() === "pending"
      )
    : false;
  const forceIncomePresent = hasLinkedPayrollEmployers || hasPendingPayrollSource;
  const forcedIncomeStatus = hasLinkedPayrollEmployers
    ? "Valid - Linked"
    : hasPendingPayrollSource
      ? "Pending"
      : undefined;
  // row.IncomeSOCRStatus is a backend-computed aggregate that has proven unreliable (can
  // read "Invalid" even when every employer is individually Valid). Recompute the overall
  // status ourselves from the same per-employer data the Gross/Net tiles use below, so the
  // badge and the dollar figures never disagree: any Unverifiable (2) employer -> "Invalid";
  // all employers Valid (1) -> "Valid"; anything less certain (mixed/pending/unknown) falls
  // back to the backend value rather than guessing.
  const { data: incomeDetailsData } = useGetOne(
    "income",
    { id: trnId },
    { enabled: !!trnId, refetchOnWindowFocus: true }
  );
  const computedIncomeStatus = useMemo(() => {
    const employmentDetails = incomeDetailsData?.employment_details;
    const employer = Array.isArray(employmentDetails?.employer)
      ? employmentDetails.employer
      : [];
    if (!employer.length) return undefined;
    const socrStatus = employmentDetails?.SOCRstatus || {};
    const statuses = employer.map((emp: any, idx: number) => {
      const sourceNum =
        parseSourceId(emp?.source_id) ??
        parseSourceId(emp?.EmployerNumber) ??
        idx + 1;
      return Number(socrStatus?.[`Source_${sourceNum}`]);
    });
    if (statuses.some((status) => status === 2)) return "Invalid";
    if (statuses.every((status) => status === 1)) return "Valid";
    return undefined;
  }, [incomeDetailsData?.employment_details]);
  const resolvedType = resolveAppType(undefined, filterValues);
  const canShow = resolvedType !== "3";
  if (!canShow) return null;

  return (
    <DocumentField
      label={label}
      source={source}
      filterValues={filterValues}
      presentKey="Income"
      requiredKey="IsRequiredIncome"
      newTagKey="NewTagIncome"
      socrStatusKey="IncomeSOCRStatus"
      documentType="Paystub"
      onClick={onClickIndividualDocsHandler}
      hideOnGuestCard
      viewerRole={viewerRole}
      applicationStatus={applicationStatus}
      reviewedKey="IncomeReviewed"
      infoPresentOverride={(row) =>
        forceIncomePresent || row?.Income === "Yes"
      }
      socrStatusOverride={(row) =>
        forcedIncomeStatus || computedIncomeStatus || row?.IncomeSOCRStatus
      }
      afterStatusWhenInfoPresent={
        isManualReviewerRole(viewerRole) || record?.IncomeReviewed
          ? () => (
              <IncomeTiles payrollEmployers={payrollEmployers} trnId={trnId} />
            )
          : undefined
      }
    />
  );
}

function BankingField({
                        filterValues,
                        onClickIndividualDocsHandler,
                        viewerRole,
                        applicationStatus,
                        source = "Banking",
                        label = "Banking",
                      }: {
  filterValues: any;
  onClickIndividualDocsHandler: (event: any, record: any, documentType: string) => void;
  viewerRole?: string;
  applicationStatus?: string;
  source?: string;
  label?: string;
}) {
  const resolvedType = resolveAppType(undefined, filterValues);
  const canShow = resolvedType !== "3";
  if (!canShow) return null;

  return (
    <DocumentField
      label={label}
      source={source}
      filterValues={filterValues}
      presentKey="Banking"
      requiredKey="IsRequiredBanking"
      newTagKey="NewTagBanking"
      socrStatusKey="BankingSOCRStatus"
      documentType="Bank Statement"
      onClick={onClickIndividualDocsHandler}
      hideOnGuestCard
      viewerRole={viewerRole}
      applicationStatus={applicationStatus}
      reviewedKey="BankingReviewed"
    />
  );
}


function OtherField({
                      filterValues,
                      onClickIndividualDocsHandler,
                      viewerRole,
                      applicationStatus,
                      source = "Other",
                      label = "Other",
                    }: {
  filterValues: any;
  onClickIndividualDocsHandler: (event: any, record: any, documentType: string) => void;
  viewerRole?: string;
  applicationStatus?: string;
  source?: string;
  label?: string;
}) {
  return (
    <DocumentField
      label={label}
      source={source}
      filterValues={filterValues}
      presentKey="Misc"
      requiredKey="IsRequiredID"   // matches your current behavior
      newTagKey="NewTagOther"
      documentType="Other"
      onClick={onClickIndividualDocsHandler}
      hideOnGuestCard               // keep hidden for app_invitation_type === "3"
      noLabel="No Doc"
      viewerRole={viewerRole}
      applicationStatus={applicationStatus}
      reviewedKey="OtherReviewed"
    />
  );
}

;(IncomeBankingField as any).subtitle = 'Bank Deposits';

const GetsubscriberinboxListDetailsContent = ({
                                                id,
                                                secondaryApp,
                                                emailcheck,
                                                appType,
                                                subsciberIdFromRecord = null as string | null,
                                                appInvitationType,
                                                applicationType,
                                                archiveCancelApp,
                                              }) => {
  const { displayedFilters, filterValues, setFilters, hideFilter } =
    useListContext();
  const AppRecord = useRecordContext();

  const { id: parmSubsciberId } = useParams();
  const subsciberId = subsciberIdFromRecord || parmSubsciberId;
  const [isLoadingViewApp, setIsLoading] = useState(false);
  const { data, total, isLoading, error } = useGetList(
    "get_subscriber_inbox_details",
    { filter: { ApplicationNumber: id, subscriberid: subsciberId }, meta: { enrichBankIncome: true } }
  );
  const isApplicant = data?.filter((check) => check.Active == false)
  const isCheckedApplicant = ((isApplicant && isApplicant.length) == (data && data?.length - 1)) ? false : true
  const listContext = useList({ data, isLoading });
  const showIncomeBankingColumn =
    resolveAppType(undefined, filterValues) !== "3" &&
    Array.isArray(data) &&
    data.some((r: any) => r?.IncomeDeposits === "Yes");
  const navigate = useNavigate();
  const dataProvider = useDataProvider();
  const [create] = useCreate();
  const { data: getUserData } = useGetIdentity();
  const viewerRole = useSelector((state: any) => state?.users?.role) || getUserData?.userrole;
  const { permissions } = usePermissions();

  const onClickDocsHandler = async (event, record) => {
    // get getalldocs list data
    const getalldocs = await dataProvider.getOne("getalldocs", {
      id: record?.id,
    });
    // const getApplicantDetails = await dataProvider.getOne("getApplicantDetails", { id: record?.Trnid });
    navigate("/ats/docview", {
      state: { getalldocs: getalldocs?.data?.data, record },
    });
  };
  const onClickViewSecondaryApp = async (event, record) => {
    // get getalldocs list data
    const getSecondaryApp = await dataProvider.getOne("getSecondaryApp", {
      id: record?.Trnid,
    });
    navigate("/ats/secondaryAppView"
      , {
        state: { getSecondaryApp: getSecondaryApp?.data?.data, record },
      }
    );
  };
  const onClickIndividualDocsHandler = async (event, record, documentType) => {
    // get getalldocs list data
    const getalldocs = await dataProvider.getOne("getalldocs", {
      id: record?.id,
    });

    await updateNewTagsForApplicantsUnconditional({
      create,
      applicationNumber: id,
      applicantData: record,
    });

    navigate("/ats/docview", {
      state: {
        getalldocs: getalldocs?.data?.data?.filter((item) =>
          documentType === "ID"
            ? item.DocumentType === "License" ||
            item.DocumentType === "Barcode" ||
            item.DocumentType === "Passport" ||
            item.DocumentType === "PermanentResidentID" ||
            item.DocumentType === "Visa"
            : item.DocumentType === documentType
        ),
        record,
        showHeading: true,
      },
    });
  };


  const [loadingStates, setLoadingStates] = useState({});
  // ADO 4855: which record's Generate/Report Options menu is open (a single
  // shared anchor, since the button is rendered per-row inside a
  // FunctionField render prop, not its own component -- no per-row hooks).
  const [vrReportMenuAnchor, setVrReportMenuAnchor] = useState<{
    anchorEl: HTMLElement;
    trnId: string;
  } | null>(null);
  const notify = useNotify();
  // One key derivation for every per-record loading map — guard, setter, and
  // render must agree or a row can spin forever / never disable.
  const getRecordLoadingKey = (record) => record?.id || record?.Trnid;
  const onClickViewAppHandler = async (event, record) => {
    const key = getRecordLoadingKey(record);
    if (loadingStates[key]) return;
    const payloadData = {
      applicationNumber: record?.AppID,
      applicantID: record?.id,
    };

    // Set loading for the specific user
    setLoadingStates((prev) => ({
      ...prev,
      [key]: true,
    }));

    try {
      const viewAppReport = await dataProvider.getOne("viewappreport", {
        id: payloadData,
      });
      openWithPopupCheck(`${viewAppReport?.data?.data}`, "_blank", undefined, {
        onBlocked: notifyPopupBlocked(notify),
      });
    } catch (error: any) {
      notify(error?.message || "Failed to open application report", {
        type: "warning",
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    } finally {
      setLoadingStates((prev) => ({
        ...prev,
        [key]: false,
      }));
    }
  };

  // Mirrors the old three-branch cascade exactly: first app type whose
  // "View Report" permission passes wins; permission stays inside the cascade
  // so a failed check falls through rather than hiding the button outright.
  const resolvePrintPermissionModule = () =>
    [
      [1, "Inbox"],
      [2, "Doc Upload App"],
      [3, "Guest Card App"],
    ].find(
      ([type, module]) =>
        (appInvitationType == type || appType == type) &&
        isSuperAdmin(
          checkModuleAccess(permissions, module, "View Report"),
          getUserData?.userrole
        )
    )?.[1];

  // ADO 4855: opens the Generate Report Options / Report Options menu
  // (content mode + preview/download) for this record's submitted report.
  const onClickPrintResultHandler = (event: React.MouseEvent<HTMLElement>, record) => {
    setVrReportMenuAnchor({ anchorEl: event.currentTarget, trnId: record.Trnid });
  };
  return (
    <>
      <ListContextProvider value={listContext}>
        <fieldset
          disabled={getUserData?.userrole == typesofUsers.docuverusAdmin && !checkModuleAccess(permissions, "Dashboard", "Edit Application")}>
          <MyDatagrid
            bulkActionButtons={false}
            header={<DatagridHeader />}
            sx={{
              "& .RaDatagrid-rowEven": { backgroundColor: "#F9F9F9" },
              "& .RaDatagrid-expandIcon": { color: "#fff" },
              "& .RaDatagrid-expandIconCell": { backgroundColor: "primary.main" },
              "& .RaDatagrid-headerCell": {
                fontWeight: "bold",
                fontSize: 12,
                minWidth: "150px", // Add minWidth for consistency
                maxWidth: "150px", // Optional, to enforce maximum column width
                textAlign: "center",
              },
              "& .RaDatagrid-table": {
                fontSize: 12,
              },
              "& .MuiToggleButton-root.Mui-selected": {
                fontWeight: 700,
              },
              "& th.MuiTableCell-root.MuiTableCell-head": {
                textAlign: "center",
                minWidth: "30px", // Add consistent minWidth for headers
              },
              "& td.MuiTableCell-root": {
                textAlign: "center",
                minWidth: "30px", // Add consistent minWidth for table cells
              },
              "& th:nth-of-type(1).MuiTableCell-root.MuiTableCell-head, th:nth-of-type(2).MuiTableCell-root.MuiTableCell-head":
                {
                  textAlign: "center",
                },
              "& .MuiTableRow-root.RaDatagrid-row": {
                verticalAlign: "top",
              },
            }}
          >

            <FunctionField
              source="Name"
              style={{ minWidth: "100px" }}
              label="Name"
              render={(record) => {
                return (
                  <>
                    <Box display={"flex"} justifyContent={"start"}>
                      <Typography
                        title={`${record.FirstName} ${record.MiddleName} ${record.LastName}`}
                        style={{
                          maxWidth: "150px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          display: "inline-block",
                        }}
                      >
                        {record.FirstName} {record.MiddleName} {record.LastName}
                      </Typography>
                    </Box>
                    <Box>
                      <small className="applicant_type">
                        {record.ApplicantType}
                      </small>{" "}

                      {!(getUserData?.userrole == typesofUsers.docuverusAdmin && !checkModuleAccess(permissions, "Dashboard", "Edit Application")) && <>{archiveCancelApp && appType == "1" && isSuperAdmin(checkModuleAccess(permissions, "Inbox", "Edit"), getUserData?.userrole)
                        ? <ApplicantNameEdit record={record} />
                        : archiveCancelApp && appType == "2" && isSuperAdmin(checkModuleAccess(permissions, "Doc Upload App", "Edit"), getUserData?.userrole)
                          ? <ApplicantNameEdit record={record} />
                          : archiveCancelApp && appType == "3" && isSuperAdmin(checkModuleAccess(permissions, "Guest Card App", "Edit"), getUserData?.userrole)
                            ? <ApplicantNameEdit record={record} />
                            : ""}</>}


                    </Box>
                  </>
                );
              }}
            />
            {canViewSerialFraudDashboardIndicator(getUserData?.userrole) && (
              <FunctionField
                label="SF"
                render={(record) =>
                  record?.hasFraudRisk === true || record?.hasFraudRisk === null ? (
                    <Box display={"flex"} justifyContent={"center"}>
                      <RiskFlagAlert isFraudRiskMatch={record?.hasFraudRisk} displayVariant="icon" />
                    </Box>
                  ) : null
                }
              />
            )}
            <FunctionField
              label={"Status"}
              source="Status"
              style={{ minWidth: "100px" }}
              render={(record) => {
                return (
                  <Box
                    display={"flex"}
                    justifyContent="center"
                    alignItems={"center"}
                  >
                    {(filterValues?.app_invitation_type == 1 ||
                      applicationType == "Application") && <CircularStatic />}
                    <ChipField
                      sx={
                        record.ApplicationStatus == "Screening"
                          ? screenedAppStatusStyle
                          : invitedAppStatusStyle
                      }
                      source="ApplicantStatus"
                    />
                  </Box>
                );
              }}
            />


            <IdField
              source="ID"
              label="ID"
              appType={appType}
              filterValues={filterValues}
              getUserData={getUserData}
              permissions={permissions}
              onClickIndividualDocsHandler={onClickIndividualDocsHandler}
              viewerRole={viewerRole}
              applicationStatus={AppRecord?.ApplicationStatus}
            />
            <SsnField
              source="SSN"
              label="SSN"
              appType={appType}
              filterValues={filterValues}
              getUserData={getUserData}
              permissions={permissions}
              onClickIndividualDocsHandler={onClickIndividualDocsHandler}
              viewerRole={viewerRole}
              applicationStatus={AppRecord?.ApplicationStatus}
            />
            <IncomeField
              source="Income"
              label="Income"
              filterValues={filterValues}
              onClickIndividualDocsHandler={onClickIndividualDocsHandler}
              viewerRole={viewerRole}
              applicationStatus={AppRecord?.ApplicationStatus}
            />
            { showIncomeBankingColumn && <IncomeBankingField
              source="IncomeBanking"
              label="Income"
              filterValues={filterValues}
              viewerRole={viewerRole}
              applicationStatus={AppRecord?.ApplicationStatus}
            /> }
            <BankingField
              source="Banking"
              label="Banking"
              filterValues={filterValues}
              onClickIndividualDocsHandler={onClickIndividualDocsHandler}
              viewerRole={viewerRole}
              applicationStatus={AppRecord?.ApplicationStatus}
            />
            <OtherField
              source="Other"
              label="Other"
              filterValues={filterValues}
              onClickIndividualDocsHandler={onClickIndividualDocsHandler}
              viewerRole={viewerRole}
              applicationStatus={AppRecord?.ApplicationStatus}
            />
            {appType == "1" && (
              <FunctionField
                source="Docs"
                style={{ minWidth: "100px" }}
                render={(record) => {
                  return (
                    archiveCancelApp &&
                    record?.ApplicantDocs &&
                    record.ApplicantStatus != "Invited" &&
                    record?.ApplicantStatus !== "Removed" && isSuperAdmin(checkModuleAccess(permissions, "View Docs", ""), getUserData?.userrole) && (
                      <Box display={"flex"} justifyContent={"center"}>
                        <MuiButton
                          onClick={(event) => onClickDocsHandler(event, record)}
                          sx={{
                            ".MuiButton-startIcon": { paddingLeft: "10px" },
                            minWidth: "80px",
                            justifyContent: "center",
                            display: "flex",
                            flexDirection: "column",
                            textTransform: "capitalize",
                          }}
                          startIcon={<FolderIcon />}
                        >
                          View
                        </MuiButton>
                      </Box>
                    )
                  );
                }}
              />
            )}
            {appType == "1" && isSuperAdmin(checkModuleAccess(permissions, "Inbox", "View Application"), getUserData?.userrole) && (
              <FunctionField
                source="App"
                style={{ minWidth: "100px" }}
                render={(record) => {
                  return (
                    record?.ApplicantStatus !== "Invited" &&
                    record?.ApplicantStatus !== "Removed" &&
                    record?.ApplicantStatus === "Submitted" && (
                      <Box display={"flex"} justifyContent={"center"}>
                        <MuiButton
                          onClick={(event) => onClickViewAppHandler(event, record)}
                          disabled={Boolean(loadingStates[getRecordLoadingKey(record)])}
                          sx={{
                            ".MuiButton-startIcon": { paddingLeft: "10px" },
                            minWidth: "80px",
                            justifyContent: "center",
                            display: "flex",
                            flexDirection: "column",
                            textTransform: "capitalize",
                          }}
                        >
                          {loadingStates[getRecordLoadingKey(record)] ? (
                            <Box sx={{ display: "flex" }}>
                              <CircularProgress size="25px" />
                            </Box>
                          ) : (
                            <>
                              <PictureAsPdfIcon />
                              View
                            </>
                          )}
                        </MuiButton>
                      </Box>
                    )
                  );
                }}
              />
            )}
            {/* <fieldset disabled={getUserData?.userrole == typesofUsers.docuverusAdmin && !checkModuleAccess(permissions, "Dashboard", "Edit Application")}> */}
            {
              (getUserData?.userrole != "Docuverus Super Admin" && getUserData?.userrole != "Docuverus Admin") ?
                appInvitationType == 1 && isSuperAdmin(checkModuleAccess(permissions, "Inbox", "Remove"), getUserData?.userrole) ? (
                  <FunctionField
                    source="Action"
                    style={{ minWidth: "100px" }}
                    render={(record) => {
                      return (
                        archiveCancelApp && (
                          <Box display={"flex"} justifyContent={"center"}>
                            {record.ApplicantType == "Applicant" ? (
                              (data && data?.length > 1 && isCheckedApplicant) ? (
                                  <div className="modal-sm">
                                    {/* <SwitchApplicant record={data} subscriberId={subsciberId}  />  */}
                                  </div>)
                                :
                                <small>&nbsp;</small>
                            ) : (record?.Active &&
                              record?.ApplicantStatus == "Invited") ||
                            (record?.Active &&
                              record?.ApplicantStatus == "In Progress") ? (
                              <ArchiveAplicant
                                record={record}
                                subsciberId={subsciberId}
                              />
                            ) : record?.ApplicantStatus == "Removed" ? (
                          <ReAddApplicant
                            record={record}
                            subsciberId={subsciberId}
                          />
                            ) : (
                              ""
                            )}
                          </Box>
                        )
                      );
                    }}
                  />
                ) : appInvitationType == 2 && isSuperAdmin(checkModuleAccess(permissions, "Doc Upload App", "Remove"), getUserData?.userrole) ? (
                  <FunctionField
                    source="Action"
                    style={{ minWidth: "100px" }}
                    render={(record) => {
                      return (
                        archiveCancelApp && (
                          <Box display={"flex"} justifyContent={"center"}>
                            {record.ApplicantType == "Applicant" ? (
                              (data && data?.length > 1 && isCheckedApplicant) ? (
                                  <div className="modal-sm">
                                    {/* <SwitchApplicant record={data} subscriberId={subsciberId}  />  */}
                                  </div>)
                                :
                                <small>&nbsp;</small>
                            ) : (record?.Active &&
                              record?.ApplicantStatus == "Invited") ||
                            (record?.Active &&
                              record?.ApplicantStatus == "In Progress") ? (
                              <ArchiveAplicant
                                record={record}
                                subsciberId={subsciberId}
                              />
                            ) : record?.ApplicantStatus == "Removed" ? (
                        <ReAddApplicant
                          record={record}
                          subsciberId={subsciberId}
                        />
                            ) : (
                              ""
                            )}
                          </Box>
                        )
                      );
                    }}
                  />
                ) : appInvitationType == 3 && isSuperAdmin(checkModuleAccess(permissions, "Guest Card App", "Remove"), getUserData?.userrole) ? (
                  <FunctionField
                    source="Action"
                    style={{ minWidth: "100px" }}
                    render={(record) => {
                      return (
                        archiveCancelApp && (
                          <Box display={"flex"} justifyContent={"center"}>
                            {record.ApplicantType == "Applicant" ? (
                              (data && data?.length > 1 && isCheckedApplicant) ? (
                                  <div className="modal-sm">
                                    {/* <SwitchApplicant record={data} subscriberId={subsciberId}  />  */}
                                  </div>)
                                :
                                <small>&nbsp;</small>
                            ) : (record?.Active &&
                              record?.ApplicantStatus == "Invited") ||
                            (record?.Active &&
                              record?.ApplicantStatus == "In Progress") ? (
                              <ArchiveAplicant
                                record={record}
                                subsciberId={subsciberId}
                              />
                            ) : record?.ApplicantStatus == "Removed" ? (
                        <ReAddApplicant
                          record={record}
                          subsciberId={subsciberId}
                        />
                            ) : (
                              ""
                            )}
                          </Box>
                        )
                      );
                    }}
                  />
                ) : null
                :
                <FunctionField
                  source="Action"
                  style={{ minWidth: "100px" }}
                  render={(record) => {
                    return (
                      archiveCancelApp && (
                        <Box display={"flex"} justifyContent={"center"}>
                          {record.ApplicantType == "Applicant" ? (
                            (data && data?.length > 1 && isCheckedApplicant) ? (
                                <div className="modal-sm">
                                  {/* <SwitchApplicant record={data} subscriberId={subsciberId}  />  */}
                                </div>)
                              :
                              <small>&nbsp;</small>
                          ) : (record?.Active &&
                            record?.ApplicantStatus == "Invited") ||
                          (record?.Active &&
                            record?.ApplicantStatus == "In Progress") ? (
                            <ArchiveAplicant
                              record={record}
                              subsciberId={subsciberId}
                            />
                          ) : record?.ApplicantStatus == "Removed" ? (
                      <ReAddApplicant
                        record={record}
                        subsciberId={subsciberId}
                      />
                          ) : (
                            ""
                          )}
                        </Box>
                      )
                    );
                  }}
                />
            }

            {/* </fieldset> */}
            {/* <fieldset disabled={getUserData?.userrole == typesofUsers.docuverusAdmin && !checkModuleAccess(permissions, "Dashboard", "Edit Application")}> */}

            <FunctionField
              label="Result"
              style={{ minWidth: "100px" }}
              render={(record) => {
                // Story 4622: hide the screening report (a system determination)
                // from subscribers until manual review is complete.
                // Reviewers can still open existing results after a new applicant is added.
                const applicationStatus =
                  AppRecord?.ApplicationStatus ?? record?.ApplicationStatus;
                const showResult = isExistingVrResultVisible(
                  applicationStatus,
                  record?.Score,
                  record?.ApplicantStatus, record?.HasPreservedScreeningReport
                );
                if (
                  shouldHideSystemAssessment(applicationStatus, viewerRole) &&
                  !canShowScreeningScoreForViewer(record?.Score, applicationStatus, viewerRole, record?.HasPreservedScreeningReport)
                )
                  return null;
                return (
                showResult &&
                // archiveCancelApp &&
                (
                  <>
                    {resolvePrintPermissionModule()
                      ? <MuiButton
                        sx={{
                          ".MuiButton-startIcon": { paddingLeft: "10px" },
                          minWidth: "80px",
                          justifyContent: "center",
                          display: "flex",
                          flexDirection: "column",
                          textTransform: "capitalize",
                          width: "100%",
                        }}
                        onClick={(event) => onClickPrintResultHandler(event, record)}
                        startIcon={<BiSolidFilePdf />}
                        variant="text"
                        color="primary"
                      >
                        View
                      </MuiButton>
                      : ""
                    }
                  </>
                )
                );
              }}
            />

            {secondaryApp && emailcheck &&
              <FunctionField
                source="2ND APP"
                style={{ minWidth: "100px" }}
                render={(record) => {
                  return (
                    <Box display={"flex"} justifyContent={"center"}>
                      <MuiButton
                        onClick={(event) => onClickViewSecondaryApp(event, record)}
                        sx={{
                          ".MuiButton-startIcon": { paddingLeft: "10px" },
                          minWidth: "80px",
                          justifyContent: "center",
                          display: "flex",
                          flexDirection: "column",
                          textTransform: "capitalize",
                        }}
                        startIcon={<CheckIcon color="primary" />}
                      >
                        View
                      </MuiButton>
                    </Box>

                  );
                }}
              />
            }
            {/* </fieldset> */}
            <FunctionField
              source="Message"
              style={{ minWidth: "100px" }}
              render={(record) => {
                return (
                  <>
                    {/* <JSONTree data={filterValues}/>   */}
                    {archiveCancelApp && (
                      <Box display={"flex"} justifyContent={"center"}>
                        {((appInvitationType === 1 ||
                            AppRecord?.ApplicationType === "Application" ||
                            filterValues.app_invitation_type == "1") &&
                          record.ApplicantStatus === "Invited") ||
                        appInvitationType === 2 ||
                        AppRecord?.ApplicationType === "Doc Upload" ||
                        filterValues.app_invitation_type == "2" ||
                        appInvitationType === 3 ||
                        AppRecord?.ApplicationType === "Guest Card" ||
                        filterValues.app_invitation_type == "3" ? (
                          <ResendInvite
                            record={record}
                            ApplicationNumber={id}
                            subscriberId={subsciberId}
                          />
                        ) : null}
                        {record?.ApplicantStatus !== "Removed" && (
                          <SendEmailToApplicant record={[record]} />
                        )}
                      </Box>
                    )}
                  </>
                );
              }}
            />
          </MyDatagrid>
        </fieldset>
      </ListContextProvider>
      <VrReportOptionsMenu
        trnId={vrReportMenuAnchor?.trnId}
        anchorEl={vrReportMenuAnchor?.anchorEl ?? null}
        onClose={() => setVrReportMenuAnchor(null)}
      />
    </>
  );
};

export const GetsubscriberinboxListDetails = (props: any) => (
  <QuickLookProvider>
    <GetsubscriberinboxListDetailsContent {...props} />
  </QuickLookProvider>
);
